import { TableCell } from '@sanlam-glacier/app-common/components';

export const mapAlignment = (value?: 'left' | 'right') => {
  switch (value) {
    case 'left':
      return TableCell.ALIGN.LEFT;
    case 'right':
      return TableCell.ALIGN.RIGHT;
    default:
      return TableCell.ALIGN.DEFAULT;
  }
};
